import { render, staticRenderFns } from "./List.vue?vue&type=template&id=dc85c1f8&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"
import style0 from "./List.vue?vue&type=style&index=0&id=dc85c1f8&prod&lang=scss"
import style1 from "./List.vue?vue&type=style&index=1&id=dc85c1f8&prod&scoped=true&lang=css"
import style2 from "./List.vue?vue&type=style&index=2&id=dc85c1f8&prod&scoped=true&lang=css"
import style3 from "./List.vue?vue&type=style&index=3&id=dc85c1f8&prod&scoped=true&lang=css"
import style4 from "./List.vue?vue&type=style&index=4&id=dc85c1f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc85c1f8",
  null
  
)

export default component.exports